"use client"

import { useState } from "react"

interface ImageWithFallbackProps {
  src: string | null | undefined
  alt: string
  fallbackText: string
  className?: string
}

// 图片缺失（null/空/非法 URL）或加载失败（404、403 等）时，用蓝色背景 SVG + 文字首字符占位
export function ImageWithFallback({ src, alt, fallbackText, className }: ImageWithFallbackProps) {
  const [failed, setFailed] = useState(false)
  const valid = !!src && (/^https?:\/\//.test(src) || src.startsWith("/"))
  const initial = fallbackText.trim().charAt(0).toUpperCase() || "图"

  if (!valid || failed) {
    return (
      <svg
        viewBox="0 0 64 64"
        preserveAspectRatio="xMidYMid slice"
        className={className}
        role="img"
        aria-label={alt}
      >
        <rect width="64" height="64" fill="#2563eb" />
        <text
          x="32"
          y="34"
          textAnchor="middle"
          dominantBaseline="central"
          fill="#ffffff"
          fontSize="28"
          fontWeight="500"
        >
          {initial}
        </text>
      </svg>
    )
  }

  return <img src={src} alt={alt} className={className} onError={() => setFailed(true)} />
}
